// Copyright (c) 2015, Intelligent IoT Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if (!window.cxplatform) window.cxplatform = {};

cxplatform.subscribe_to_newsletter = function (opts, btn) {
	return cx.call({
		type: "POST",
		method: "cxcore.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { email: opts.email },
		callback: opts.callback,
	});
};
